export const defaultImagePath = "./default-gallery-image.svg";
export const jsonFilePath = "./src/data/profiles.json";
export const jsonFilePathForPEI = "./src/data/profiles.pei.json";

export const sitemapPath = "./public/content_hubs-sitemap.xml";

export const sideBarNavElements = [
  {
    title: "Overview",
    url: "overview",
    value: "overview",
  },
  {
    title: "Related stories",
    url: "headlines",
    value: "headlines",
  },
  {
    title: "Contacts",
    url: "contacts",
    value: "contacts",
  },
  {
    title: "LP",
    value: "LP",
  },
  {
    parent: "LP",
    title: "Investment appetite",
    url: "investment-appetite",
    value: "investment-appetite",
  },
  {
    parent: "LP",
    title: "Fund commitments",
    url: "fund-commitments",
    value: "fund-commitment",
  },
  {
    title: "GP",
    value: "GP",
  },
  {
    parent: "GP",
    title: "Funds managed",
    url: "funds-managed",
    value: "funds-managed",
  },
];

export const partnerStatuses = {
  LP: "LP",
  GP: "GP",
  "LP/GP": "LP/GP",
};

export const GTMCode = process.env.NEXT_PUBLIC_BASE_URL?.includes("stage")
  ? "GTM-WB6VLQP"
  : "GTM-NLC9Q2";

const cookieBotDomainGroups: Record<string, string> = {
  agri: '6ac80e9a-ff03-483b-9fa8-8578a3245f6f',
  buyout: 'a0233a1d-1664-43e0-90b3-bf0e1542d460',
  ii: '5f6577c8-ecce-4afd-8501-f36d9948b8a6',
  npm: 'c1b204eb-ad7f-4d78-bb68-b7aa871af498',
  pdi: 'fbdfb740-9653-4b40-bf22-9da4f8b5de49',
  pehub: '45234713-845f-4ee9-a6ea-75abbbfe195d',
  pei: '62979884-703f-40fc-b47b-a56fb42d257c',
  pere: '022d4522-9e95-41a1-b7ae-a1861c61b06b',
  si: '613b50b7-6260-4c6c-9f71-c49cb952b287'
};

export const setDefaultConsentStatesScript = () => `
  window.dataLayer = window.dataLayer || [];

  dataLayer.push(['consent', 'default', {
    'ad_storage': 'denied',
    'ad_personalization': 'denied',
    'ad_user_data': 'denied',
    'analytics_storage': 'denied'
  }]);
`;

export const getCookieBotDomainGroup = (brand: string) => cookieBotDomainGroups[brand.toLocaleLowerCase()];

export const getCookieBotConfiguration = () => JSON.stringify({
  Frameworks: {
    IABTCF2: {
      AllowedVendors: [68, 78, 98, 126, 275, 278, 315, 373, 565, 755, 772, 804, 812, 815, 1029, 1031, 1126],
      AllowedGoogleACVendors: [574],
      AllowedPurposes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      AllowedSpecialPurposes: [1, 2],
      AllowedFeatures: [],
      AllowedSpecialFeatures: [],
      VendorRestrictions: []
    }
  }
})
